// ACTION TYPES
// eslint-disable-next-line import/prefer-default-export
export const actionTypes = {
  APPLICATION_INITIALISE_REQUEST: 'APPLICATION_INITIALISE_REQUEST',
  APPLICATION_INITIALISE_SUCCESS: 'APPLICATION_INITIALISE_SUCCESS',
  APPLICATION_INITIALISE_FAILURE: 'APPLICATION_INITIALISE_FAILURE',

  COUNTRIES_FETCH_REQUEST: 'COUNTRIES_FETCH_REQUEST',
  COUNTRIES_FETCH_SUCCESS: 'COUNTRIES_FETCH_SUCCESS',
  COUNTRIES_FETCH_FAILURE: 'COUNTRIES_FETCH_FAILURE',

  SET_APPLICATION_SHOULD_UPDATE_SUCCESS: 'SET_APPLICATION_SHOULD_UPDATE_SUCCESS',
  SET_APPLICATION_SHOULD_UPDATE_FAILURE: 'SET_APPLICATION_SHOULD_UPDATE_FAILURE',

  CHANGE_LOCALE: 'CHANGE_LOCALE',
  CHANGE_LOCALE_LANGS: 'CHANGE_LOCALE_LANGS',
  USER_DETAILS_FETCHED: 'USER_DETAILS_FETCHED',
  SHOW_SEARCH_BOX: 'SHOW_SEARCH_BOX',
  LOG_IN: 'LOG_IN',
  LOG_IN_SUCCESS: 'LOG_IN_SUCCESS',
  LOG_IN_FAILURE: 'LOG_IN_FAILURE',
  PRO_CALLS_RECEIVED: 'PRO_CALLS_RECEIVED',
  PERSONAL_CALLS_RECEIVED: 'PERSONAL_CALLS_RECEIVED',
  TRANSACTIONS_RECEIVED: 'TRANSACTIONS_RECEIVED',
  RESET_TRANSACTIONS: 'RESET_TRANSACTIONS',
  GET_TRANSACTIONS: 'GET_TRANSACTIONS',
  GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE',

  GET_WITHDRAW: 'GET_WITHDRAW',
  WITHDRAW_RECEIVED: 'WITHDRAW_RECEIVED',
  GET_WITHDRAW_FAILURE: 'GET_WITHDRAW_FAILURE',

  AUTH_FAILURE: 'AUTH_FAILURE',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE',
  LOGGED_OFF: 'LOGGED_OFF',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  EDIT_FAILURE: 'EDIT_FAILURE',
  FETCHING_REGISTRATION: 'FETCHING_REGISTRATION',
  VERIFY_FAILURE: 'VERIFY_FAILURE',
  VERIFY_SUCCESS: 'VERIFY_SUCCESS',
  RESET_SUCCESS: 'RESET_SUCCESS',
  RESET_FAILURE: 'RESET_FAILURE',
  PHOTO_UPLOADED: 'PHOTO_UPLOADED',
  PHOTO_UPLOAD_FAILURE: 'PHOTO_UPLOAD_FAILURE',
  PHOTO_UPLOAD_CLEAR_STATUS: 'PHOTO_UPLOAD_CLEAR_STATUS',
  FORGOT_PASSWORD_RESET: 'FORGOT_PASSWORD_RESET',
  SET_CATEGORIES: 'SET_CATEGORIES',
  SEND_CONTACT_MESS: 'SEND_CONTACT_MESS',
  SEND_CONTACT_MESS_FAILURE: 'SEND_CONTACT_MESS_FAILURE',
  SEND_CONTACT_MESS_SUCCESS: 'SEND_CONTACT_MESS_SUCCESS',
  SET_STATE: 'SET_STATE',
  SET_STATE_SUCCESS: 'SET_STATE_SUCCESS',
  SET_STATE_FAILURE: 'SET_STATE_FAILURE',
  CLOSE_COMMUNICATE_MODAL: 'CLOSE_COMMUNICATE_MODAL',
  CLOSE_COMMUNICATE_MODAL_CHAT: 'CLOSE_COMMUNICATE_MODAL_CHAT',
  OPEN_COMMUNICATE_MODAL: 'OPEN_COMMUNICATE_MODAL',
  OPEN_COMMUNICATE_MODAL_CHAT: 'OPEN_COMMUNICATE_MODAL_CHAT',
  CHOOSE_CHAT_PERSON: 'CHOOSE_CHAT_PERSON',
  CLEAR_CHATS: 'CLEAR_CHATS',
  CLEAR_CALL_BRIEFS: 'CLEAR_CALL_BRIEFS',

  CHANGE_UNREAD_MSG: 'CHANGE_UNREAD_MSG',
  CREATE_CALL: 'CREATE_CALL',
  CREATE_CALL_ERROR: 'CREATE_CALL_ERROR',
  GET_CALL_INFO: 'GET_CALL_INFO',
  CALEE_IS_BUSY: 'CALEE_IS_BUSY',
  PROCESSING_CALL: 'PROCESSING_CALL',
  SPEAKING: 'SPEAKING',
  STOP_COMMUNICATION: 'STOP_COMMUNICATION',
  PICK_UP_CALL: 'PICK_UP_CALL',

  MODIFYING_CARDS: 'MODIFYING_CARDS',
  GETING_CARDS_SUCCESS: 'GETING_CARDS_SUCCESS',
  GETING_CARDS_FAILURE: 'GETING_CARDS_FAILURE',

  MODIFYING_BANKS: 'MODIFYING_BANKS',
  GETING_BANKS_SUCCESS: 'GETING_BANKS_SUCCESS',
  GETING_BANKS_FAILURE: 'GETING_BANKS_FAILURE',
  VERIFICATION_ID_UPLOADED: 'VERIFICATION_ID_UPLOADED',
  VERIFICATION_ID_UPLOAD_FAILURE: 'VERIFICATION_ID_UPLOAD_FAILURE',
  VERIFICATION_ID_STATUS_RESET: 'VERIFICATION_ID_STATUS_RESET',
  CHECK_VERIFICATION_ID_FAIL: 'CHECK_VERIFICATION_ID_FAIL',
  CHECK_VERIFICATION_ID_SUCCESS: 'CHECK_VERIFICATION_ID_SUCCESS',

  GET_PROS: 'GET_PROS',
  GET_PROS_FAILURE: 'GET_PROS_FAILURE',
  GET_PROS_SUCCESS: 'GET_PROS_SUCCESS',
  SET_PRO_SEARCH_PARAMS: 'SET_PRO_SEARCH_PARAMS',
  RESET_PRO_SEARCH_PARAMS: 'RESET_PRO_SEARCH_PARAMS',

  GET_USER_ACTIVITY: 'GET_USER_ACTIVITY',
  GET_USER_ACTIVITY_SUCCESS: 'GET_USER_ACTIVITY_SUCCESS',
  GET_USER_ACTIVITY_FAILURE: 'GET_USER_ACTIVITY_FAILURE',
  SET_ACTIVITY_SEARCH_PARAMS: 'SET_ACTIVITY_SEARCH_PARAMS',
  RESET_ACTIVITY_SEARCH_PARAMS: 'RESET_ACTIVITY_SEARCH_PARAMS',

  GET_USER_DETAILS: 'GET_USER_DETAILS',
  RESET_USER_DETAILS: 'RESET_USER_DETAILS',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILURE: 'GET_USER_DETAILS_FAILURE',

  CHANGE_CHAT: 'CHANGE_CHAT',
  CHANGE_CONNECTION_STATUS: 'CHANGE_CONNECTION_STATUS',
  CHANGE_VIDEO_STATUS: 'CHANGE_VIDEO_STATUS',

  TOP_UP: 'TOP_UP',
  TOP_UP_SUCCESS: 'TOP_UP_SUCCESS',
  TOP_UP_PENDING: 'TOP_UP_PENDING',
  TOP_UP_FAILURE: 'TOP_UP_FAILURE',

  GET_AMOUNTS_SUCCESS: 'GET_AMOUNTS_SUCCESS',
  GET_AMOUNTS_FAILURE: 'GET_AMOUNTS_FAILURE',
  GET_AMOUNTS: 'GET_AMOUNTS',

  SEND_WITHDRAW_START: 'SEND_WITHDRAW_START',
  SEND_WITHDRAW_SUCCESS: 'SEND_WITHDRAW_SUCCESS',
  SEND_WITHDRAW_FAILURE: 'SEND_WITHDRAW_FAILURE',

  GET_STRIPE_KEY_SUCCESS: 'GET_STRIPE_KEY_SUCCESS',
  GET_STRIPE_KEY_FAILURE: 'GET_STRIPE_KEY_FAILURE',

  GET_AVAILABILITY: 'GET_AVAILABILITY',
  GET_AVAILABILITY_SUCCESS: 'GET_AVAILABILITY_SUCCESS',
  GET_AVAILABILITY_FAILURE: 'GET_AVAILABILITY_FAILURE',

  SET_AVAILABILITY: 'SET_AVAILABILITY',
  SET_AVAILABILITY_SUCCESS: 'SET_AVAILABILITY_SUCCESS',
  SET_AVAILABILITY_FAILURE: 'SET_AVAILABILITY_FAILURE',

  UPDATE_AVAILABILITY: 'UPDATE_AVAILABILITY',
  UPDATE_AVAILABILITY_SUCCESS: 'UPDATE_AVAILABILITY_SUCCESS',
  UPDATE_AVAILABILITY_FAILURE: 'UPDATE_AVAILABILITY_FAILURE',

  DELETE_AVAILABILITY: 'DELETE_AVAILABILITY',
  DELETE_AVAILABILITY_SUCCESS: 'DELETE_AVAILABILITY_SUCCESS',
  DELETE_AVAILABILITY_FAILURE: 'DELETE_AVAILABILITY_FAILURE',

  GET_SECTORS_REQUSET: 'GET_SECTORS_REQUSET',
  GET_SECTORS_SUCCESS: 'GET_SECTORS_SUCCESS',
  GET_SECTORS_FAILURE: 'GET_SECTORS_FAILURE',

  SET_URL: 'SET_URL',

  FEATURED_SERVICE: 'FEATURED_SERVICE',
  FEATURED_SERVICE_SUCCESS: 'FEATURED_SERVICE_SUCCESS',
  FEATURED_SERVICE_FAILURE: 'FEATURED_SERVICE_FAILURE',

  FEATURED_SERVICES: 'FEATURED_SERVICES',
  FEATURED_SERVICES_SUCCESS: 'FEATURED_SERVICES_SUCCESS',
  FEATURED_SERVICES_FAILURE: 'FEATURED_SERVICES_FAILURE',
  RESET_FEATURED_SERVICE: 'RESET_FEATURED_SERVICE',

  FEATURED_AGREEMENT: 'FEATURED_AGREEMENT',
  FEATURED_AGREEMENT_SUCCESS: 'FEATURED_AGREEMENT_SUCCESS',
  FEATURED_AGREEMENT_FAILURE: 'FEATURED_AGREEMENT_FAILURE',

  SET_TIME_OFFSET: 'SET_TIME_OFFSET',

  BRANCH_IO_DATA: 'BRANCH_IO_DATA',
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  UPDATE_USER_SETTINGS_SUCCESS: 'UPDATE_USER_SETTINGS_SUCCESS',
  UPDATE_USER_SETTINGS_FAILURE: 'UPDATE_USER_SETTINGS_FAILURE',

  GET_DEEP_LINK: 'GET_DEEP_LINK',
  GET_DEEP_LINK_SUCCESS: 'GET_DEEP_LINK_SUCCESS',
  GET_DEEP_LINK_FAILURE: 'GET_DEEP_LINK_FAILURE',

  GET_BADGE: 'GET_BADGE',
  GET_BADGE_SUCCESS: 'GET_BADGE_SUCCESS',
  GET_BADGE_FAILURE: 'GET_BADGE_FAILURE',

  UPDATE_BADGE: 'UPDATE_BADGE',
  UPDATE_BADGE_SUCCESS: 'UPDATE_BADGE_SUCCESS',
  UPDATE_BADGE_FAILURE: 'UPDATE_BADGE_FAILURE',

  GLOBAL_MESSAGE: 'GLOBAL_MESSAGE',
  UPLOAD_FILE_REQUSET: 'UPLOAD_FILE_REQUSET',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',

  DELETE_FILE_REQUSET: 'DELETE_FILE_REQUSET',
  DELETE_FILE_SUCCESS: 'DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'DELETE_FILE_FAILURE',

  SET_REDIRECT_LINK: 'SET_REDIRECT_LINK',

  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  REGISTRATION_PENDING_ACTIVATION: 'REGISTRATION_PENDING_ACTIVATION',

  TOKEN_VALIDATE_REQUEST: 'TOKEN_VALIDATE_REQUEST',
  TOKEN_VALIDATE_SUCCESS: 'TOKEN_VALIDATE_SUCCESS',
  TOKEN_VALIDATE_FAILURE: 'TOKEN_VALIDATE_FAILURE',
  TOKEN_VALIDATE_RESET: 'TOKEN_VALIDATE_RESET',

  APPLICATION_CHECK_OS: 'APPLICATION_CHECK_OS',
  APPLICATION_SET_DETECTED: 'APPLICATION_SET_DETECTED',

  CHANGE_RECONNECTION_STATUS: 'CHANGE_RECONNECTION_STATUS',

  SIGN_IN_FETCH_USER_DATA_REQUEST: 'SIGN_IN_FETCH_USER_DATA_REQUEST',
  SIGN_IN_FETCH_USER_DATA_SUCCESS: 'SIGN_IN_FETCH_USER_DATA_SUCCESS',
  SIGN_IN_FETCH_USER_DATA_FAILURE: 'SIGN_IN_FETCH_USER_DATA_FAILURE',
  SIGN_IN_LOGIN_REQUEST: 'SIGN_IN_LOGIN_REQUEST',
  SIGN_IN_LOGIN_SUCCESS: 'SIGN_IN_LOGIN_SUCCESS',
  SIGN_IN_LOGIN_FAILURE: 'SIGN_IN_LOGIN_FAILURE',
  SIGN_IN_SOCIAL_LOGIN_REQUEST: 'SIGN_IN_SOCIAL_LOGIN_REQUEST',
  SIGN_IN_PUT_RESPONSE: 'SIGN_IN_PUT_RESPONSE',
  SIGN_IN_SET_PROCESSED: 'SIGN_IN_SET_PROCESSED',

  SIGN_UP_REGISTER_REQUEST: 'SIGN_UP_REGISTER_REQUEST',
  SIGN_UP_REGISTER_SUCCESS: 'SIGN_UP_REGISTER_SUCCESS',
  SIGN_UP_REGISTER_FAILURE: 'SIGN_UP_REGISTER_FAILURE',
  SIGN_UP_RESET: 'SIGN_UP_RESET',
  CATEGORIES_FETCH_REQUEST: 'CATEGORIES_FETCH_REQUEST',
  CATEGORIES_FETCH_SUCCESS: 'CATEGORIES_FETCH_SUCCESS',
  CATEGORIES_FETCH_FAILURE: 'CATEGORIES_FETCH_FAILURE',

  FIND_PRO_FILTER_REQUEST: 'FIND_PRO_FILTER_REQUEST',
  FIND_PRO_FILTER_SUCCESS: 'FIND_PRO_FILTER_SUCCESS',
  FIND_PRO_FILTER_FAILURE: 'FIND_PRO_FILTER_FAILURE',
  FIND_PRO_SET_ACTIVE_FILTER_TAGS: 'FIND_PRO_SET_ACTIVE_FILTER_TAGS',
  FIND_PRO_SET_SEARCH_PHRASE: 'FIND_PRO_SET_SEARCH_PHRASE',
  FIND_PRO_SET_SORT: 'FIND_PRO_SET_SORT',
  FIND_PRO_RESET: 'FIND_PRO_RESET',

  FORGOT_PASSWORD_POST_REQUEST: 'FORGOT_PASSWORD_POST_REQUEST',
  FORGOT_PASSWORD_POST_SUCCESS: 'FORGOT_PASSWORD_POST_SUCCESS',
  FORGOT_PASSWORD_POST_FAILURE: 'FORGOT_PASSWORD_POST_FAILURE',
  FORGOT_PASSWORD_RESET_REQUEST: 'FORGOT_PASSWORD_RESET_REQUEST',
  FORGOT_PASSWORD_RESET_SUCCESS: 'FORGOT_PASSWORD_REST_SUCCESS',
  FORGOT_PASSWORD_RESET_FAILURE: 'FORGOT_PASSWORD_RESET_FAILURE',
  FORGOT_PASSWORD_SET_RESETTING_MODE: 'FORGOT_PASSWORD_SET_RESETTING_MODE',

  MESSAGE_SET_TEXT: 'MESSAGE_SET_TEXT',
  MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST: 'MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST',
  MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS: 'MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS',
  MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE: 'MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE',
  MESSAGE_RESET: 'MESSAGE_RESET',

  GET_BOOKINGS_REQUEST: 'GET_BOOKINGS_REQUEST',
  GET_BOOKINGS_SUCCESS: 'GET_BOOKINGS_SUCCESS',
  GET_BOOKINGS_FAILURE: 'GET_BOOKINGS_FAILURE',
  CANCEL_BOOKING_SUCCESS: 'CANCEL_BOOKING_SUCCESS',
  CANCEL_BOOKING_FAILURE: 'CANCEL_BOOKING_FAILURE',
  GET_BOOKING_REFUND_SUCCESS: 'GET_BOOKING_REFUND_SUCCESS',
  GET_BOOKING_REFUND_FAILURE: 'GET_BOOKING_REFUND_FAILURE',
  CANCEL_BOOKING_NOT_CONFIRMED: 'CANCEL_BOOKING_NOT_CONFIRMED',

  REFRESH_LOGGED_IN_USER_DETAILS: 'REFRESH_LOGGED_IN_USER_DETAILS',
  REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS: 'REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS',
  REFRESH_LOGGED_IN_USER_DETAILS_FAILURE: 'REFRESH_LOGGED_IN_USER_DETAILS_FAILURE',

  CALL_TIMER_RESET: 'CALL_TIMER_RESET',
  CALL_TIMER_TICK: 'CALL_TIMER_TICK',
  CALL_TIMER_TIMESTAMP: 'CALL_TIMER_TIMESTAMP',
};



// WEBPACK FOOTER //
// ./actions/index.js